import { createAction, props } from '@ngrx/store';

import { ModalDeliveryShareModel, SharedReason } from '../../../../../core/models';

const ACTION_KEY = '[Modal Delivery Share]';

export const loadSharedReason = createAction(`${ACTION_KEY} load shared reason`);
export const loadSharedReasonSuccess = createAction(
  `${ACTION_KEY} load shared reason success`,
  props<{ reasons: SharedReason[] }>(),
);
export const loadSharedReasonError = createAction(`${ACTION_KEY} load shared reason error`);
export const sendDelivery = createAction(
  `${ACTION_KEY} load send delivery`,
  props<{ deliveryShare: ModalDeliveryShareModel }>(),
);
export const sendDeliverySuccess = createAction(`${ACTION_KEY} load send delivery success`);
export const sendDeliveryError = createAction(`${ACTION_KEY} load send delivery error`);
